import type { ExecuteShareTaskResponse } from '../types';

export const DuplicateExecuteApi = Symbol('DuplicateExecuteApi');

export interface DuplicateExecuteApi {
    executeShareTask(data: string): Promise<ExecuteShareTaskResponse>
    executeShareTaskAgent(source_id: string, target_id: string): Promise<string>
}
